import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Tamil from './language/tamil.json';
import English from './language/english.json';
import Portuguese from './language/portuguese.json';
import German from './language/german.json';
import Spanish from './language/spanish.json';
import French from './language/french.json';
import Norwegian from './language/norwegian.json';
import Arabic from './language/arabic.json';


i18n
  .use(LanguageDetector) 
  .use(initReactI18next) 
  .init({
    resources: {
      english: {
        translation: English,
      },
    },
    fallbackLng: localStorage.getItem('i18nextLng') || 'english', 
    interpolation: {
      escapeValue: false, 
    },
partialBundledLanguages: true,   // helps when we overwrite bundles
    react: {
      useSuspense: false,            // recommended when loading async
    },
  });


export default i18n;
